export const OVERALL_DEPARTMENT_ID = -1;
